import type { PharmacyDetails } from '@/models/pharmacy-details'

export const usePharmacyPageCases = () => {
  const userStore = useUserStore()
  const { performPharmacyCheck, setHasDifferentPharmaciesAfterLogin } = usePharmacySwitchStore()

  /**
   * - Non-authenticated or authenticated
   * - If authenticated, user pharmacy and cookie pharmacy are the same
   * - Url pharmacy is different
   *
   * @selectedPharmacy Cookie (same as user pharmacy if authenticated), can be empty
   * @newPharmacy Url
   *
   * @example selectedPharmacyId=undefined -> user not authenticated, cookie is not defined and url is set
   * @example user is logged in (without pharmacy), selectedPharmacyId = cookie, url is set
   * @example user is logged in (has pharmacy), selectedPharmacyId=cookie=user, url is set
   */
  const cookieVsUrl = (urlPharmacyId: number) => performPharmacyCheck({
    selectedPharmacyId: userStore.getPharmacyCookie(),
    newPharmacyId: urlPharmacyId,
    onKeep(_pharmacy: PharmacyDetails) {
    },
    onSwitch(_pharmacy: PharmacyDetails) {
    },
  })

  /**
   * - Authenticated
   * - User pharmacy and url pharmacy are the same
   * - Cookie pharmacy is different, can be empty
   *
   * @selectedPharmacy Url (same as user pharmacy)
   * @newPharmacy Cookie (can be empty)
   *
   * @example user is logged in (has pharmacy), selectedPharmacyId=url=user, cookie can be set or not
   *
   */
  const urlAndUserVsCookie = (urlAndUserPharmacyId: number) => {
    setHasDifferentPharmaciesAfterLogin(true)
    performPharmacyCheck({
      selectedPharmacyId: urlAndUserPharmacyId,
      newPharmacyId: userStore.getPharmacyCookie(),
      onKeep: (_pharmacy: PharmacyDetails) => {
      },
      onSwitch(_pharmacy: PharmacyDetails) {
      },
    })
  }

  /**
   * - Authenticated
   * - User pharmacy and url are different
   * - Cookie pharmacy is different from both
   *
   * @selectedPharmacy User
   * @newPharmacy Url
   *
   * @example user is logged in (has pharmacy), selectedPharmacyId=user, url is set, cookie is different from both
   *
   */
  const userVsUrl = (urlPharmacyId: number) => {
    setHasDifferentPharmaciesAfterLogin(true)
    performPharmacyCheck({
      selectedPharmacyId: userStore.userPharmacyId,
      newPharmacyId: urlPharmacyId,
      onKeep: (_pharmacy: PharmacyDetails) => {
      },
      onSwitch(_pharmacy: PharmacyDetails) {
      },
    })
  }

  return {
    cookieVsUrl,
    urlAndUserVsCookie,
    userVsUrl,
  }
}
